import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output} from "@angular/core";
import {ScreenLayoutEditorModel} from "../screen-layout-editor.model";
import {ITEM_TYPE, TouchItemData} from "../../../screen-layout.data";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {ScreenLayoutEntityModel} from "../../../screen-layout-entity.model";
import {EditService} from "../../../../../framework/entity/edit/edit-page/edit.service";

/**
 * Touch item within a screen layout menu
 */
@Component({
    selector: "wbo-screen-layout-touch-item",
    templateUrl: "./screen-layout-touch-item.component.html",
    styleUrls: ["./screen-layout-touch-item.component.scss"]
})
export class ScreenLayoutTouchItemComponent implements OnDestroy {
    @Output() public commandsToggled$: EventEmitter<boolean> = new EventEmitter<boolean>();

    private _item: TouchItemData;

    isLeftCommandsToggled: boolean;
    isRightCommandsToggled: boolean;

    destroyed: boolean;

    constructor(public model: ScreenLayoutEditorModel,
                private stackedPageService: FUIStackedPageService,
                private changeDetectorRef: ChangeDetectorRef,
                private entityModel: ScreenLayoutEntityModel,
                public editService: EditService) {
    }

    @Input() get item(): TouchItemData {
        return this._item;
    }

    set item(value: TouchItemData) {
        if (this._item !== value) {
            this.entityModel.loadIconIfRequired(value).then((updated: boolean) => {
                if (updated && !this.destroyed) {
                    this.changeDetectorRef.detectChanges();
                }
            });
        }

        this._item = value;
    }

    selectItem() {
        this.model.selectItem(this._item);
    }

    selectSubMenu(): void {
        if (this._item.itemType === ITEM_TYPE.SUB_MENU) {
            this.model.selectSubMenu(this._item);
        }
    }

    delete(): void {
        this.model.removeItem(this._item);
    }

    clear(): void {
        this.model.clearItem(this._item);
    }

    edit(): void {
        this.model.editItem(this.item).then(() => {
        });
    }

    leftCommandsToggled(toggled: boolean) {
        this.isLeftCommandsToggled = toggled;
        this.commandsToggled$.emit(this.isLeftCommandsToggled || this.isRightCommandsToggled);
    }

    rightCommandsToggled(toggled: boolean) {
        this.isRightCommandsToggled = toggled;
        this.commandsToggled$.emit(this.isLeftCommandsToggled || this.isRightCommandsToggled);
    }

    get showNavigateTo(): boolean {
        return this.item.itemType === ITEM_TYPE.SUB_MENU && this.model.numOfRows <= 10;
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

}
